module.exports = __webpack_public_path__ + "img/enstsc_3.3397202c.png";